import { BuilderType, projectsCacheTags } from './projectsApiHelpers';

export type ClientOwner = {
  id: number;
  client_id: number;
  target_client_id: number;
  user_id: number;
  created_at?: string;
  updated_at?: string;
};

export const clientOwnersApi = (builder: BuilderType) => ({
  getClientOwners: builder.query<ClientOwner, void>({
    query: () => `service/client-owners`,
    providesTags: [projectsCacheTags.CLIENT_OWNERS],
  }),

  createClientOwner: builder.mutation<ClientOwner, Omit<ClientOwner, 'id'>>({
    query: (owner) => ({
      url: `service/client-owners`,
      method: 'POST',
      body: owner,
    }),
    invalidatesTags: [
      projectsCacheTags.CLIENT_OWNERS,
      projectsCacheTags.CLIENTS,
      projectsCacheTags.PROJECTS,
    ],
  }),

  updateClientOwner: builder.mutation<ClientOwner, ClientOwner>({
    query: (owner) => ({
      url: `service/client-owners/${owner.id}`,
      method: 'PUT',
      body: owner,
    }),
    invalidatesTags: [
      projectsCacheTags.CLIENT_OWNERS,
      projectsCacheTags.CLIENTS,
      projectsCacheTags.PROJECTS,
    ],
  }),

  deleteClientOwner: builder.mutation<ClientOwner, number>({
    query: (id) => ({
      url: `service/client-owners/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: [projectsCacheTags.CLIENT_OWNERS],
  }),
});
